import React from 'react'
import { LPInvestment } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { LPInvestmentTable } from './LPInvestmentTable'
import { HelpProps } from '@/components/common/Help'

type Props = {
  investments: LPInvestment[]
  shortname: string
  helpText?: string
  helpProps?: HelpProps
}

export const LPInvestments: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle helpText={props.helpText} helpProps={props.helpProps}>
        LP投資
      </CardTitle>
      <LPInvestmentTable list={props.investments} shortname={props.shortname} />
    </>
  )
}
